import { Grid, Rating, Typography, useTheme } from '@mui/material'
import { MdCheck } from 'react-icons/md'
import { useLocation } from 'react-router-dom'
import { BackToGroupLink, Stepper } from '.'
import { ReactComponent as WalterLearning } from '../assets/WalterLearning.svg'
import { ReactComponent as WalterSanteColor } from '../assets/WalterSanteColor.svg'
import { FormData, StepType } from '../utils/sharedTypes'

type DrawerPropsType = {
  form: FormData
  steps: StepType[]
}

const Drawer = ({ form, steps }: DrawerPropsType) => {
  const theme = useTheme()
  const location = useLocation()
  const product = form.product || form.products[0]

  return (
    <Grid
      item
      sm={4}
      md={3}
      container
      direction="column"
      justifyContent="space-between"
      alignItems="space-between"
      wrap="nowrap"
      sx={{
        position: 'fixed',
        background: theme.palette.primary.light,
        p: 2,
        pl: 4,
        height: '100vh',
        display: { xs: 'none', sm: 'flex' },
        width: '300px',
      }}
    >
      <Grid item sx={{ cursor: 'pointer' }}>
        {location.pathname.includes('/sante') ? (
          <WalterSanteColor
            width="162px"
            onClick={() => {
              window.open('https://walter-learning.com/sante', '_self')
            }}
          />
        ) : (
          <WalterLearning
            width="180px"
            onClick={() => {
              window.open('https://walter-learning.com', '_self')
            }}
          />
        )}
      </Grid>
      {form.registration_group && (
        <Grid item sx={{ mt: 1.5 }}>
          <BackToGroupLink registrationGroup={form.registration_group} />
        </Grid>
      )}
      <Grid item sx={{ flexGrow: 1, pt: 8 }}>
        {product?.product_code && (
          <img
            src={`https://walter-resources.s3.eu-west-3.amazonaws.com/formations/${product.product_code.toLowerCase()}/img2/logotype_black.svg`}
            width="85%"
            height="auto"
            style={{ marginBottom: '16px' }}
          />
        )}
        <Typography variant="body2">{product?.description}</Typography>
        <Stepper steps={steps} />
      </Grid>
      <Grid item container direction="column" sx={{ mb: 4 }}>
        <Grid item container alignItems="center" sx={{ mb: 2, mt: 2 }}>
          <Typography variant="body1" sx={{ mr: 1, fontWeight: 'bold' }}>
            4.7 sur Google
          </Typography>
          <Rating value={4.7} precision={0.1} readOnly />
        </Grid>
        <Grid item>
          <Grid item container alignItems="center" sx={{ pb: 1 }} wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Formations 100% en ligne</Typography>
          </Grid>
          <Grid item container alignItems="center" sx={{ pb: 1 }} wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Par des spécialistes reconnus</Typography>
          </Grid>
          <Grid item container alignItems="center" wrap="nowrap">
            <MdCheck size="12" style={{ color: theme.palette.success.main, marginRight: 4 }} />
            <Typography variant="body2">Sur ordinateur, tablette ou mobile</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Drawer
